<template>
  <div class="notifications-wrap content">
    <settings-menu></settings-menu>
    <div class="settings-body">
      <div class="settings-body-inner">

        <div class="row">
          <div class="col-md-6">
            <div class="s-block" v-if="Object.keys(settings).length">
              <div class="s-block-header">Email Notifications
                <font-awesome-icon class="text-right" :icon="['fas', 'envelope']"/>
              </div>
              <div class="s-block-body d-block">
                <div class="contacts-list">
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>
                        <font-awesome-icon :icon="['fas', 'user-plus']"/>
                      </td>
                      <td>NEW Donor Sign-Up
                        <div class="info">Receive an email any time a supporter creates a donor account</div>
                      </td>
                      <td class="switch-column">
                        <switches
                            v-model="settings['email.donor_registered'].enabled"
                            type-bold="true" theme="dashboard"></switches>
                      </td>
                    </tr>

                    <tr>
                      <td width="77px">
                        <font-awesome-icon :icon="['fas', 'envelope-open-dollar']"/>
                      </td>
                      <td>One-Time Donations
                        <div class="info">Receive an email any time a new one-time donation is made</div>
                      </td>
                      <td class="switch-column" width="66px"
                      >
                        <switches
                            v-model="settings['email.donation_created'].enabled"
                            type-bold="true" theme="dashboard"></switches>
                      </td>
                    </tr>

                    <tr>
                      <td width="77px">
                        <font-awesome-icon :icon="['fas', 'calendar-check']"/>
                      </td>
                      <td>Monthly Donation Started
                        <div class="info">Receive an email when a donor creates a new monthly donation</div>
                      </td>
                      <td class="switch-column" width="66px"
                      >
                        <switches
                            v-model="settings['email.monthly_donation_started'].enabled"
                            type-bold="true" theme="dashboard"></switches>
                      </td>
                    </tr>

                    <tr>
                      <td width="77px">
                        <font-awesome-icon :icon="['fas', 'donate']"/>
                      </td>
                      <td>New Round-Up Donor
                        <div class="info">Receive an email when a donor enrolls in Round-Ups</div>
                      </td>
                      <td class="switch-column" width="66px"
                      >
                        <switches
                            v-model="settings['email.roundup_donation_started'].enabled"
                            type-bold="true" theme="dashboard"></switches>
                      </td>
                    </tr>

                    <tr>
                      <td>
                        <font-awesome-icon :icon="['fas', 'comment-alt-dots']"/>
                      </td>
                      <td>NEW Messages
                        <div class="info">Receive a notification for any incoming messages</div>
                      </td>
                      <td class="switch-column">
                        <switches
                            v-model="settings['email.message_received'].enabled"
                            type-bold="true" theme="dashboard"></switches>
                      </td>
                    </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="s-block">
              <div class="s-block-header">Summary Reports</div>
              <div class="s-block-body d-block">
                <div class="contacts-list">
                  <table class="table">
                    <tbody>
                    <tr>
                      <td>Coming Soon
                        <div class="info">We'll let you know when these summary reports are available!</div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div v-if="isEdited" class="settings-btn-bottom">
        <div class="text-right btn-wrap">
          <a href="#" v-on:click.prevent="resetSettings" class="btn btn-sm btn-cancel">Cancel</a>
          <a href="#" v-on:click.prevent="saveSettings" class="btn btn-sm btn-sm-edit">Save</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SettingsMenu from './menu.vue';
  import Switches from 'vue-switches';
  import {notificationSettings} from '@/utils/api';
  import {mapState} from "vuex";

  export default {
    name: 'Notifications',
    metaInfo: {
      title: 'Settings - Notifications',
    },
    components: {
      SettingsMenu,
      Switches,
    },
    mounted() {
      this.updateSettings();
    },
    methods: {
      updateSettings(){
        notificationSettings.getNotificationSettings(this.activeCharityId).then(settings => {

          this.settings = [...settings.notifications.settings].reduce((res, setting) => {
            res[setting.name] = {
              id: setting.id,
              enabled: setting.enabled,
            };

            return res;
          }, {});
          this.initialSettings = JSON.parse(JSON.stringify(this.settings));
        });
      },
      resetSettings() {
        this.settings = JSON.parse(JSON.stringify(this.initialSettings));
      },
      saveSettings() {
        let promises =[];
        Object.keys(this.settings).map(key => {
          if(this.settings[key].enabled !== this.initialSettings[key].enabled){
            promises.push(notificationSettings.updateNotificationSetting(
              this.settings[key].id , + this.settings[key].enabled, this.activeCharityId
            ));
          }
        });

        Promise.all(promises).then(() => {
          this.$message('Notification settings updated');
          this.initialSettings = JSON.parse(JSON.stringify(this.settings));
        });
      },
    },
    computed: {
      ...mapState({
        activeCharityId: state => state.auth.activeCharityId,
      }),
      isEdited() {
        return Object.keys(this.initialSettings).length
          && JSON.stringify(this.settings) !== JSON.stringify(this.initialSettings);
      },
    },
    watch: {
      'adminInfo'() {
        this.updateSettings();
      },
    },
    data() {
      return {
        settings: {},
        initialSettings: {},
      };
    },
  };
</script>
<style lang="sass" scoped>
  .notifications-wrap
    .table
      .svg-inline--fa
        font-size: 24px
    .s-block
      .table
        td:first-of-type
          text-align: left
          padding-left: 25px
    .s-block-header
      .svg-inline--fa
        font-size: 20px
        float: right

</style>
<style lang="sass">
  .switch-column,
  .switcher-wrap
    text-align: right
    .vue-switcher-theme--dashboard
      vertical-align: middle
      margin-bottom: 0
      margin-right: 15px

    .vue-switcher-theme--dashboard
      input
        display: none
      & > div
        height: 17px
        width: 36px
        top: 0
        background-color: #1bb157
        &:after
          // for the circle on the switch
          background-color: white
          margin-left: -16px
          top: 1px
          width: 15px
          height: 15px
      &.vue-switcher--unchecked
        div
          background-color: #677788
          &:after
            left: 17px
</style>
